export default {
  data () {
    return {
      firstActivate: false,
    }
  },
  mounted () {
    this.getAppToken(true)
    if (this.$route.query.IS_DEV) {
      this.init()
    }
    this.$nextTick(() => {
      this.firstActivate = true
    })
  },
  activated () {
    if (this.firstActivate) {
      this.init(false)
    }
  },
}